module.exports = __webpack_public_path__ + "img/201805-6.19a90ddb.jpeg";